import { Box } from "@chakra-ui/react";

const Phrase: React.FC<React.PropsWithChildren<Record<string, any>>> = ({ children, ...props }) => (
  <Box fontFamily="GT Walsheim" fontWeight="bold" fontSize={["1.5rem", "3.5rem"]} color="white" {...props}>
    {children}
  </Box>
);

export default Phrase;
